import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {apiDeletePaymentMethod, PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Flow} from "../../../flows/Flow.js";
import {Toast} from "../../../../ui/Toast.jsx";


@autoredraw(PaymentMethodStore)
export class InlineUserDashboardRemoveCardPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeCard,
        };
    }

    @wrapInSpinner
    async removeCard() {
        await apiDeletePaymentMethod(Flow.dashboard.card.id);
        Router.back();
        Toast.showSuccess(Messages.cardRemoved);
    }

    render() {
        const {styleSheet} = this;
        const {card} = Flow.dashboard;

        return [
            <div>{Messages.removeCardEndingIn(card.getBrand(), card.getLastDigits())}</div>,
            <MerchantButton
                label={Messages.remove}
                className={styleSheet.actionButton}
                onClick={() => this.removeCard()}
            />,
            <div className={styleSheet.backButton} onClick={() => Router.back()}>
                {Messages.cancel}
            </div>
        ];
    }
}
